import { Action, createReducer, on } from '@ngrx/store';
import { PermissionsActions } from '../actions/actions-type.action';
import { GROUP_TYPES } from '../../models/enums/permission-names';

export interface PermissionsManagerState {
    permissionsList: any[];
    tournamentPermissionsList: any[];
    tournamentChatPermissionsList: any[];
    isLoading: boolean;
    detailedPermissions: any[];
}

const initialState: any = {
    permissionsList: [],
    tournamentPermissionsList: [],
    tournamentChatPermissionsList: [],
    isLoading: false,
    detailedPermissions: [],
};

export const reducer = createReducer(
    initialState,
    on(
        PermissionsActions.fetchPermissionsRequestsSuccess,
        (state, action) => ({
            ...state,
            permissionsList: action.payload.finalizedPermissions
        })
    ),
    on(
        PermissionsActions.fetchTournamentPermissionsRequestsSuccess,
        (state, action) => ({
            ...state,
            tournamentPermissionsList: action.payload.finalizedPermissions
        })
    ),
    on(
        PermissionsActions.fetchTournamentEntitiesPermissionsRequestsSuccess,
        (state, action) => {
            return {
                ...state,
                tournamentChatPermissionsList: action.payload[0].finalizedPermissions
            }
        }
    ),
    on(
        PermissionsActions.fetchDetailedPermissionsRequestsSuccess,
        (state, action) => ({
            ...state,
            detailedPermissions: action.payload
        })
    ),
    on(
        PermissionsActions.fetchTournamentGroupSuccess,
        (state, action) => ({
            ...state,
            tournamentModeratorGroupId: action.payload.searchName == GROUP_TYPES.Moderator
            ? action.payload
            : state.tournamentModeratorGroupId,
            tournamentOperatorGroupId: action.payload.searchName == GROUP_TYPES.Operator
            ? action.payload
            : state.tournamentOperatorGroupId,
        })
    ),);

export const permissionsReducer = (state: any, action: Action) =>
    reducer(state, action);
